import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCAPTCHAInput = ({ onVerify }) => {
  const recaptchaRef = useRef();

  const handleChange = (value) => {
    if (onVerify) {
      onVerify(value);
    }
  };

  return (
    <div className="recaptcha-container">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_NV_CAPTCHA_KEY}
        onChange={handleChange}
      />
    </div>
  );
};

export default ReCAPTCHAInput;
